export const list = [
  {
    url: '../../assets/img/banner_0227.png',
    href: '/candidate/vote',
    outsideLink: false,
    queryData: 'vote'
  }
]



//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/assets/js/bannerConfig.js
// module id = ../../../../../src/assets/js/bannerConfig.js
// module chunks = main